import React, { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import "./index.scss";
import AssignedActions from "./AssignedActions";
import CreateForm from "./CreateForm";
import { connect, useSelector, useDispatch } from "react-redux";
import { getAnalyticsApplist } from "../../services/graphs/actions";
import Loader from "../../components/Loader2";
import Footer from "../../components/Footer";
import { changePage } from "../../services/page/actions";

const Actions = ({ changePage }) => {
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [marginTop, setMarginTop] = useState(0);
  // eslint-disable-next-line
  const { analytics_app_list, isLoading, error } = useSelector(
    ({ graphState }) => ({
      analytics_app_list: graphState.analytics_app_list,
      isLoading: graphState.isLoading,
      error: graphState.error,
    })
  );

  useEffect(() => {
    let tableContainer = document.getElementById("action-container");
    let tableHeight = tableContainer.offsetHeight;
    let tableTop = tableContainer.offsetTop;
    let windowHeight = window.innerHeight;
    let marginGiven = windowHeight - (tableHeight + tableTop) - 70;
    if (marginGiven > 0) setMarginTop(marginGiven);
    else setMarginTop(0);
  }, [analytics_app_list]);

  useEffect(() => changePage(0), [changePage]);
  useEffect(() => {
    if (!analytics_app_list) {
      dispatch(getAnalyticsApplist({}));
    }
  }, [analytics_app_list, dispatch]);

  return (
    <div
      className="dashboard_container"
      style={{ paddingLeft: 0, paddingRight: 0 }}
    >
      <Navbar />
      {/* <Sidebar /> */}
      <div className="action-container" id="action-container">
        <h1>App List</h1>
        <div className="content">
          {modal && <CreateForm setModal={setModal} />}
          <div className="full_section">
            <h2>
              APPS
              <button onClick={() => setModal(true)} className="clear">
                Create API Key
              </button>
            </h2>
            {isLoading ? (
              <Loader />
            ) : (
              <AssignedActions
                data={analytics_app_list ? analytics_app_list : []}
              />
            )}
          </div>
        </div>
      </div>
      <Footer marginTop={marginTop} />
    </div>
  );
};
export default connect(null, { changePage })(Actions);
